import * as types from './types'
import { IPaginatedRequest } from '@cbgms/api'

export const loadFailedExports = (params: IPaginatedRequest) => ({
  type: [types.GET_FAILEDEXPORTS, types.GET_FAILEDEXPORTS_SUCCESS, types.GET_FAILEDEXPORTS_FAILED],
  payload: {
    api: 'support',
    request: {
      method: 'GET',
      url: '/modules/failed-exports',
      params
    }
  }
})
